<template>
  <div class="study-task">
    <div class="title">
      <h3>学习任务</h3>
      <h4 v-for="(item, index) in summary" :key="index">{{item}}</h4>
    </div>

    <div class="task">
      <div class="task-item"
        v-for="(item, index) in taskList"
        :key="item.taskId"
      >
        <div class="mark-cover"
          v-if="locked(item)"
          @click.stop.prevent="clickAction"></div>
        <div class="task-item__title">
          <i class="icon" :class="{active: item.progressStatus === 'FINISHED'}"></i>
          <p>
            {{ index + 1 }}. {{item.taskName}}<span class="obligatory">-{{item.required ? '必' : '选'}}修</span>
          </p>
        </div>
        <div class="task-item__content">
          <template v-if="item.taskType === 'ALBUM'">
            <course-task :desc="item.detail.description" :item="item.detail" :cover="item.detail.cover" />
          </template>
          <template v-else-if="item.taskType === 'ARTICLE'">
            <article-task
              :desc="item.detail.description"
              :id="item.detail.articleId"
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
            />
          </template>
          <template v-else-if="item.taskType === 'DOCUMENT'">
            <pdf-task
              :desc="item.detail.description"
              :list="item.detail.files"
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
            />
          </template>
          <template v-else-if="item.taskType === 'OBJECTIVE'">
            <target-task
              :desc="item.detail.description"
              :id="id"
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
              :inputted="item.detail.inputted"
            />
          </template>
          <template v-else-if="item.taskType === 'DIALOG'">
            <quiz-task
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
              :desc="item.detail.description" :id="item.taskId" />
          </template>
          <template v-else-if="item.taskType === 'QUESTIONNAIRE'">
            <question-task
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
              :desc="item.detail.description" :url="item.detail.url" />
          </template>
          <template v-else-if="item.taskType === 'REPORT'">
            <report-task
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
              :desc="item.detail.description" :id="id" />
          </template>
          <template v-else-if="item.taskType === 'CERTIFICATE'">
            <certificate-task
            :status="taskStatus === 'LOCKED'"
            :detail="item.detail"/>
          </template>
          <template v-else-if="item.taskType === 'MEETING'">
            <meeting-task
              :desc="item.detail.description"
              :cover="item.detail.cover"
              :title="item.detail.subject"
              :time="item.detail.openedAt"
              :meetingNumber="item.detail.meetingNumber"
              :meetingPass="item.detail.password"
              :status="taskStatus === 'LOCKED'"
              :required="item.required"
            />
          </template>
          <template v-else-if="item.taskType === 'PAPER'">
            <exam-task
            :required="item.required"
            :question="item.detail"
            :status="taskStatus === 'LOCKED'" :taskId="String(item.taskId)" />
          </template>
          <template v-else-if="item.taskType === 'LIVE'">
            <LiveTask :taskStatus="taskStatus" :status="taskStatus === 'LOCKED'" :detail="item.detail" />
          </template>
          <template v-else-if="item.taskType === 'HOMEWORK'">
            <HomeWork :item="item" :descript="item.detail.description"></HomeWork>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

import CourseTask from './course/index.vue'
import ArticleTask from './article/index.vue'
import TargetTask from './target/index.vue'
import PdfTask from './pdf/index.vue'
import QuizTask from './quiz/index.vue'
import QuestionTask from './question/index.vue'
import ReportTask from './report/index.vue'
import CertificateTask from './certificate/index.vue'
import MeetingTask from './meeting/index.vue'
import ExamTask from './exam/index.vue'
import LiveTask from './live'
import HomeWork from './homework'
const emit = defineEmits(['task'])
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  summary: {
    type: Array,
    default: () => {
      return []
    }
  },
  id: {
    type: Number,
    default: 0
  },
  taskList: {
    type: Array,
    default: () => {
      return []
    }
  },
  taskStatus: {
    type: String,
    default: ''
  },
  planType: {
    type: String,
    default: 'TODAY'
  }
})

const clickAction = () => {
  if (props.taskStatus === 'NOT_STARTED') {
    emit('task', 0)
  } else if (props.taskStatus === 'LOCKED') {
    if (props.planType === 'STAGE') {
      emit('task', 2)
    } else {
      emit('task', 1)
    }
  } else if (props.taskStatus === 'IMPACTED') {
    emit('task', 2)
  }
}
const locked = (item) => {
  // 未开始
  if (props.taskStatus === 'NOT_STARTED') {
    return true;
  }
  if (props.planType === 'STAGE') {
    // 闯关模式 未解锁选修可以做
    return props.taskStatus === 'LOCKED' && item.required;
  } else {
    if (props.taskStatus === 'LOCKED') {
      // 未解锁
      return true;
    } else if (props.taskStatus === 'IMPACTED') {
      // 受影响
      return item.required;
    } else {
      return false;
    }
  }
}

</script>

<style lang="scss" scoped>
.study-task {
  padding: 0 24px 64px;
  .title {
    margin-bottom: 48px;
    h3 {
      color: #232323;
      font-size: 36px;
      margin-bottom: 20px;
    }
    h4 {
      font-weight: normal;
      color: #232323;
      font-size: 28px;
      margin-bottom: 20px;
    }
  }

  .task {
    position: relative;
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 8;
      &.transparent {
        background-color: transparent;
      }
    }
    .mark-cover {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
    }
  }

  .task-item {
    padding-bottom: 60px;
    position: relative;
    &:last-child {
      padding-bottom: 0;
    }
    &::after {
      content: "";
      position: absolute;
      left: 13px;
      top: 38px;
      height: 96%;
      width: 4px;
      background-color: rgba(225, 226, 230, 0.29);
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
    &__title {
      display: flex;
      align-items: center;
      .icon {
        display: inline-block;
        width: 30px;
        height: 30px;
        box-sizing: border-box;
        border: 2px solid #B1B1B3;
        border-radius: 50%;
        margin-right: 30px;
        background: #fff;
        &.active {
          background-image: url('../img/task_complete.png');
          background-size: cover;
          border: none;
        }
      }
      p {
        color: #212224;
        font-size: 32px;
        font-weight: 600;
        flex: 1;
        overflow: hidden;
        .obligatory {
          color: #969799;
          font-size: 28px;
          font-weight: normal;
        }
      }
    }

    &__content {
      padding-left: 60px;
      margin-top: 20px;
    }
  }
}
</style>
